import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=3c58bf68&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"
import style0 from "@/styles/styled_cell.less?vue&type=style&index=0&id=3c58bf68&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c58bf68",
  null
  
)

export default component.exports